import { formatDistanceToNow } from 'date-fns'

const NO_DATE = '–'

/**
 * Filter the given date to be displayed as date from now.
 *
 * @param  input {String}
 *         Date in ISO format: yyyy-MM-dd
 *
 * @return {String} The formatted date
 */
export function dateFromNow(input) {
  if (!input) {
    return NO_DATE
  }

  const date = new Date(input)
  return formatDistanceToNow(date, { addSuffix: true })
}
